import axiosClient from "api/apiClient";

export const APICreateTestCustom = (data: object) => {
    return axiosClient.post("tests/createPersonalTest", data);
};